<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayout="column"  fxLayoutAlign="start center">
    <div fxFlex class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search style templates</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadData()"
          (keyup.esc)="searchTerm=''; loadData()"
          name="searchTerm"
          placeholder="Search Name">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="loadData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button mat-flat-button color="accent" (click)="add()">
          <mat-icon>add</mat-icon> Add
        </button>
        <button *ngIf="isSituUser" mat-flat-button color="primary" (click)="uploadCSV()" matTooltip="Import style templates from CSV">
          <mat-icon>file_upload</mat-icon> Import CSV
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <mat-chip-list #optionChipList>
          <mat-chip *ngIf="searchTerm" class="green-chip" color="accent">
            <span>{{searchTerm}}</span>
            <button matChipRemove (click)="searchTerm = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="productName !== productNames.Facade"
            [matTooltip]="productName === productNames.Panorama ? 'Showing only situVIEW templates' : 'Show only situVIEW templates'"
            [class.green-chip]="productName === productNames.Panorama"
            (click)="productName === undefined ? setProductName(productNames.Panorama) : ''">
            <span>situVIEW</span>
            <button *ngIf="productName != undefined" matChipRemove (click)="productName = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="productName !== productNames.Panorama"
            [matTooltip]="productName === productNames.Facade ? 'Showing only situFACADE templates' : 'Show only situFACADE templates'"
            [class.green-chip]="productName === productNames.Facade"
            (click)="productName === undefined ? setProductName(productNames.Facade) : ''">
            <span>situFACADE</span>
            <button *ngIf="productName != undefined" matChipRemove (click)="productName = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="isHidden !== true"
            [matTooltip]="isHidden === false ? 'Hiding Hidden templates' : 'Hide Hidden templates'"
            [class.green-chip]="isHidden === false"
            (click)="isHidden === undefined ? setIsHidden(false) : ''">
            <mat-icon>visibility</mat-icon>
            <button *ngIf="isHidden != undefined" matChipRemove (click)="isHidden = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="isHidden !== false"
            [matTooltip]="isHidden === true ? 'Showing only Hidden templates' : 'Show only Hidden templates'"
            [class.green-chip]="isHidden === true"
            (click)="isHidden === undefined ? setIsHidden(true) : ''">
            <mat-icon>visibility_off</mat-icon>
            <button *ngIf="isHidden != undefined" matChipRemove (click)="isHidden = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="globalOnly !== false"
            [matTooltip]="globalOnly === true ? 'Showing only Global templates' : 'Show only Global templates'"
            [class.green-chip]="globalOnly === true"
            (click)="globalOnly === undefined ? setGlobalOnly(true) : ''">
            <mat-icon>public</mat-icon>
            <button *ngIf="globalOnly != undefined" matChipRemove (click)="globalOnly = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-content>
    <mat-accordion multi="true" class="w-100">
      <mat-expansion-panel *ngFor="let groupName of objectKeys(data)">
        <mat-expansion-panel-header>
          <mat-panel-title fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span>{{ groupName }}</span>
            <mat-icon *ngIf="data[groupName].home.length > 0" class="home-icon">home</mat-icon>
            <mat-icon *ngIf="data[groupName].tag.length > 0" class="tag-icon">label</mat-icon>
            <mat-icon *ngIf="data[groupName].global.length > 0" class="global-icon">public</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container *ngFor="let precedence of ['home', 'tag', 'global']; let isLast = last">
          <ng-container *ngIf="data[groupName][precedence].length > 0">
            <mat-card class="contrast" *ngFor="let item of data[groupName][precedence]" [ngClass]="{ 'home-template': precedence === 'home', 'tag-template': precedence === 'tag', 'global-template': precedence === 'global' }" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="80" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
                  <img *ngIf="item?.thumbnailUrl" [lazyLoad]="item.thumbnailUrl" class="thumbnail" alt="">
                  <div *ngIf="!item?.thumbnailUrl" class="thumbnail banner-incomplete" alt=""></div>
                  <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchTerm"></strong>
                  <small class="text-info" *ngIf="item?.home?.name">{{ item.home.name }}</small>
                  <small class="text-info" *ngIf="item?.tag?.name">{{ item.tag.name }}</small>
                  <mat-icon *ngIf="precedence === 'home'" class="home-icon" matTooltip="Home Template">home</mat-icon>
                  <mat-icon *ngIf="precedence === 'tag'" class="tag-icon" matTooltip="Tag Template">label</mat-icon>
                  <mat-icon *ngIf="precedence === 'global'" class="global-icon" matTooltip="Global Template">public</mat-icon>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                  <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row">
                    <mat-icon class="m-l-10 m-t-2" *ngIf="item.isHidden" mat-icon-button color="primary" matTooltip="Hidden">visibility_off</mat-icon>
                    <mat-icon class="m-l-10 m-t-2" *ngIf="!item.isHidden" mat-icon-button color="accent" matTooltip="Visible">visibility</mat-icon>
                    <mat-icon class="m-l-10 m-t-2" *ngIf="item?.productName === productNames.Panorama" mat-icon-button color="accent" matTooltip="situVIEW only">image</mat-icon>
                    <mat-icon class="m-l-10 m-t-2" *ngIf="item?.productName === productNames.Facade" mat-icon-button color="accent" matTooltip="situFACADE only">panorama</mat-icon>
                    <button mat-icon-button color="accent" aria-label="Edit Style Template" matTooltip="Edit Style Template" (click)="onClickStyleTemplate(item, item?.home?.name, item?.tag?.name)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            
            <!-- Separator between groups -->
            <div *ngIf="!isLast" class="separator" fxLayout="row" fxLayoutAlign="center center">
              <mat-icon>arrow_downward</mat-icon>
            </div>
          </ng-container>
        </ng-container>

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>